<div id="paycards-container">

    <h2>Cartes de crédit</h2>

    <div id="pay-card-list">
        <div class="card-item" [class.expired]="creditCardsService.isExpiredCard(card)" *ngFor="let card of cardsList"
            (click)="onClickCard(card, $event)" #showtooltip>
            <div [apply-write-rights]="rights.Payment" class="card-details" data-testid="card"
                [class.is-selected]="card.PaymentMethodCardId === selectedCardId"
                [class.expired]="creditCardsService.isExpiredCard(card)">
                <div class="card-logos-line" tooltip="{{getTooltip(card)}}" [showin]="showtooltip">
                    <div class="card-logo-card">
                        <span
                            *ngIf="card.CardBrand === ListTypeCard.visa && selectedCardId !== card.PaymentMethodCardId"
                            uiSvg source="assets/images/visa-20"></span>
                        <span
                            *ngIf="card.CardBrand === ListTypeCard.visa && selectedCardId === card.PaymentMethodCardId"
                            uiSvg source="assets/images/visa-20-white"></span>

                        <span *ngIf="card.CardBrand === ListTypeCard.mastercard" uiSvg
                            source="assets/images/master-card-20"></span>

                        <span *ngIf="card.CardBrand === ListTypeCard.cb" uiSvg source="assets/images/cb-20"></span>
                    </div>
                    <div class="card-default-line" tooltip="{{getTooltip(card)}}" [showin]="showtooltip">
                        <span class="card-defaut-info" *ngIf="card.PaymentMethodCardId === defaultCardId">Carte par
                            défaut&nbsp;</span>
                        <fa-icon *ngIf="card.PaymentMethodCardId === defaultCardId" [icon]="faCheckCircle"
                            tooltip="{{getTooltip(card)}}" [showin]="showtooltip"></fa-icon>
                        <fa-icon
                            *ngIf="!card.PaymentMethodCardId === defaultCardId && !creditCardsService.isExpiredCard(card)"
                            [icon]="faCircle" tooltip="{{getTooltip(card)}}" [showin]="showtooltip"></fa-icon>
                    </div>
                </div>
                <div class="card-number" tooltip="{{getTooltip(card)}}" [showin]="showtooltip">
                    <span class="cardnum-hidden">••••&nbsp;&nbsp;••••&nbsp;&nbsp;••••&nbsp;&nbsp;</span><span
                        class="cardnum">{{card.CardNumer | slice:12 }}</span>
                </div>
                <div class="card-expired" [class.expired]="creditCardsService.isExpiredCard(card)"
                    tooltip="{{getTooltip(card)}}" [showin]="showtooltip">
                    <span>
                        EXPIRE FIN
                    </span>
                    <span class="exp-date">
                        {{card.CardExpiryDate | slice:0:2 }}&nbsp;/&nbsp;20{{card.CardExpiryDate | slice:2 }}
                    </span>
                </div>
                <div class="card-footer-info">
                    <div class="card-holder-name" data-testid="card-holder-name" tooltip="{{getTooltip(card)}}"
                        [showin]="showtooltip">
                    </div>
                    <div [apply-write-rights]="rights.Payment" class="card-delete" data-testid="card-delete"
                        tooltip="Supprimer la CB" (click)="onRemoveCard($event, card.PaymentMethodCardId)">
                        <fa-icon [icon]="faTrashAlt"></fa-icon>
                    </div>
                </div>

            </div>
        </div>
        <div class="card-item" (click)="clickNewCard.emit($event)">
            <div *ngIf="pageName === 'payment-means'" class="card-item-add">
                <div class="head">
                    <div class="img-title">
                        <img src="assets/images/add-credit-card-v2.png" alt="Ajout carte">
                    </div>
                    <div class="title">
                        Nouvelle carte
                    </div>
                </div>
                <div class="content">
                    L’ajout d’une carte de crédit nécessite un premier paiement avec celle-ci.
                </div>
            </div>
            <div *ngIf="pageName === 'select-pay'" class="card-item-pay-new" data-testid="card-add-new">
                <span uiSvg source="assets/images/new-card-icon"></span>
                Payer avec une nouvelle carte
            </div>
        </div>
    </div>
</div>
